import { Draft, PayloadAction } from '@reduxjs/toolkit';

import IGetStatusDateChangedInterventionResponse from 'services/httpClient/responses/intervention/IGetStatusDateChangedInterventionResponse';

import { IInterventionData } from '../../initialState';

interface IGetStatusDateChangedInterventionsSuccessWithDataAction {
  interventionStatus: IGetStatusDateChangedInterventionResponse[];
}

function getStatusDateChangedSuccess(
  draft: Draft<IInterventionData>,
  action: PayloadAction<IGetStatusDateChangedInterventionsSuccessWithDataAction>,
) {
  draft.getStatusDateChanged.config.isLoading = false;
  draft.getStatusDateChanged.values = action.payload.interventionStatus.map(
    interventionStatus => ({
      createdAt: interventionStatus.created_at,
      oldStatus: interventionStatus.old_status,
      newStatus: interventionStatus.new_status,
    }),
  );
}

export default getStatusDateChangedSuccess;
